export class PresentationOption {
	public languageArr: Array<any> = [];
	public mode = ``;
	public selected = false;
	public name = ``;
}
